module.exports = __webpack_public_path__ + "img/identity.de53d562.jpg";